export default __webpack_public_path__ + "static/media/website.ddb9f2fd.svg";